module.exports = __webpack_public_path__ + "static/media/closed-up-basketball@2x.369803ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/closed-up-basketball@2x.png
// module id = 165
// module chunks = 0